interface IntersectionObserverSettings extends IntersectionObserverInit {
  target: Element,
  once?: boolean
}

export const intersectionObserver = (setting: IntersectionObserverSettings, callback: (target: Element) => void): void => {
  const observer = new IntersectionObserver((entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback(entry.target);
        setting.once && observer.unobserve(entry.target);
      }
    });
  }, setting);

  observer.observe(setting.target);
}